export default "__VITE_ASSET__67dd479c__"